import apiClient from './apiClient';

// Get IT Sales Partners
export const getItSalesPartnersApi = async (params) => {
  const response = await apiClient.get('/partners/itsales-partners', { params });
  return response.data;
};

// Add IT Sales Partner
export const addItSalesPartnerApi = async (partnerData) => {
  if (!partnerData) {
    throw new Error('Partner data is required');
  }
  
  const formData = new FormData();
  
  // Append all fields to FormData
  Object.keys(partnerData).forEach(key => {
    if (key === 'logo' && partnerData[key]) {
      formData.append(key, partnerData[key]);
    } else if (key === 'stripeLicenseKeyId' && Array.isArray(partnerData[key])) {
      formData.append(key, JSON.stringify(partnerData[key]));
    } else if (key !== 'refreshParams' && partnerData[key] !== null && partnerData[key] !== undefined) {
      formData.append(key, partnerData[key]);
    }
  });

  const response = await apiClient.post('/partners/itsales-partners', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Edit IT Sales Partner
export const editItSalesPartnerApi = async (partnerData) => {
  if (!partnerData) {
    throw new Error('Partner data is required');
  }
  
  const formData = new FormData();
  
  // Append all fields to FormData including id
  Object.keys(partnerData).forEach(key => {
    if (key === 'logo' && partnerData[key]) {
      formData.append(key, partnerData[key]);
    } else if (key === 'stripeLicenseKeyId' && Array.isArray(partnerData[key])) {
      formData.append(key, JSON.stringify(partnerData[key]));
    } else if (key !== 'refreshParams' && partnerData[key] !== null && partnerData[key] !== undefined) {
      formData.append(key, partnerData[key]);
    }
  });

  const response = await apiClient.put('/partners/itsales-partners', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Delete IT Sales Partner
export const deleteItSalesPartnerApi = async (id) => {
  const response = await apiClient.delete('/partners/itsales-partners', { data: { _id: id } });
  return response.data;
};

// Change IT Sales Status
export const changeItSalesStatusApi = async (data) => {
  const { refreshParams, ...statusData } = data;
  const response = await apiClient.patch('/partners/itsales-partner/status', statusData);
  return response.data;
};

// Reset IT Sales Password
export const resetItSalesPasswordApi = async (data) => {
  const response = await apiClient.put('/partners/itsales-partner/reset-password', {
    itSalesId: data.itSalesId,
    password: data.password
  });
  return response.data;
};

// Get Licenses
export const getLicenseslistApi = async () => {
  const response = await apiClient.get('/license/list');
  return response.data;
};

// Get IT Sales Partner OEM List
export const getItSalesPartnerOemListApi = async (params) => {
  const { _id, ...queryParams } = params;
  const response = await apiClient.get(`/partners/itsales-partners/oem-partners/list`, { 
    params: { ...queryParams, _id },
    skipAuthRedirect: true
  });
  return response.data;
};

// Get IT Sales Partner OEM Users
export const getItSalesPartnerOemUsersApi = async (params) => {
  const response = await apiClient.get('/partners/itsales-partners/oem-partners/user-list', { 
    params,
    skipAuthRedirect: true
  });
  return response.data;
};

// Resend IT Sales Verification Email
export const resendItSalesVerificationEmailApi = async (itsalesId) => {
  const response = await apiClient.post('/partners/itsales-partner/resend-verification-email', {
    itsalesId
  });
  return response.data;
};